/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaAudioVolumeSXIcon16Solid = forwardRef('MediaAudioVolumeSXIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M3.704 5 7.51 1.694a.9.9 0 0 1 1.49.68v11.252a.9.9 0 0 1-1.49.68L3.704 11H1.5A1.5 1.5 0 0 1 0 9.5v-3A1.5 1.5 0 0 1 1.5 5h2.204Z" }),
        React.createElement("path", { d: "M10.382 10.619a.875.875 0 0 1 0-1.238L11.763 8l-1.381-1.381A.875.875 0 1 1 11.62 5.38L13 6.763l1.382-1.382a.875.875 0 1 1 1.237 1.238L14.24 8l1.38 1.381a.875.875 0 0 1-1.237 1.238l-1.381-1.382-1.381 1.382a.875.875 0 0 1-1.238 0Z" })));
});
